import styles from "./registration.module.css";

export default function RegistrationPanel({
  tournament,
  userRegistration,
  onRegisterClick,
  onCancelRegistrationClick,
}) {
  const isConfirmed = userRegistration && userRegistration.status === "paid";
  const isPending = userRegistration && userRegistration.status === "pending";
  const hasActiveRegistration =
    userRegistration &&
    !["cancelled", "refunded", "failed"].includes(userRegistration.status);

  const safeCurrentRegistrations = Math.max(
    0,
    tournament?.currentRegistrations ?? 0,
  );
  const safeMaxPlayers = Math.max(0, tournament?.maxPlayers ?? 0);
  const progressPercent =
    safeMaxPlayers > 0
      ? Math.min(
          100,
          Math.max(0, (safeCurrentRegistrations / safeMaxPlayers) * 100),
        )
      : 0;

  return (
    <div className={styles.registrationPanel}>
      <h2 className={styles.panelTitle}>Tournament Info</h2>

      <div className={styles.statsGrid}>
        <div className={styles.statBox}>
          <span className={styles.statLabel}>Entry Fee</span>
          <span className={styles.statValue}>
            {tournament.registrationPrice
              ? `₹${tournament.registrationPrice}`
              : "Free"}
          </span>
        </div>

        <div className={styles.statBox}>
          <span className={styles.statLabel}>Players Registered</span>
          <span className={styles.statValue}>
            {safeCurrentRegistrations}/{safeMaxPlayers}
          </span>
        </div>
      </div>

      <div className={styles.progressBar}>
        <div
          className={styles.progress}
          style={{ width: `${progressPercent}%` }}
        />
      </div>

      {hasActiveRegistration && (
        <div className={styles.registrationStatus}>
          {isConfirmed && (
            <div className={styles.statusBadge}>
              <span className={styles.statusDot} />
              <span>You're Registered</span>
            </div>
          )}

          {isPending && (
            <div
              className={styles.statusBadge}
              style={{ background: "rgba(255, 193, 7, 0.1)", color: "#ffc107" }}
            >
              <span
                className={styles.statusDot}
                style={{ background: "#ffc107" }}
              />
              <span>Payment Pending</span>
            </div>
          )}

          <div className={styles.registrationDetails}>
            <div className={styles.detailItem}>
              <span className={styles.detailLabel}>Team Name</span>
              <span className={styles.detailValue}>
                {userRegistration.teamName || "-"}
              </span>
            </div>

            <div className={styles.detailItem}>
              <span className={styles.detailLabel}>Game ID</span>
              <span className={styles.detailValue}>
                {userRegistration.gameId}
              </span>
            </div>

            <div className={styles.detailItem}>
              <span className={styles.detailLabel}>Status</span>
              <span
                className={styles.detailValue}
                style={{ textTransform: "capitalize" }}
              >
                {userRegistration.status}
              </span>
            </div>
          </div>
          {isPending && (
            <button
              className={styles.registerButton}
              onClick={onRegisterClick}
              style={{ marginTop: "1rem", marginBottom: "0.5rem" }}
            >
              Complete Payment
            </button>
          )}

          {userRegistration.status !== "cancelled" && (
            <button
              className={styles.secondaryButton}
              onClick={onCancelRegistrationClick}
            >
              {isConfirmed ? "Cancel Registration" : "Discard Registration"}
            </button>
          )}
        </div>
      )}

      {!hasActiveRegistration && (
        <button className={styles.registerButton} onClick={onRegisterClick}>
          Register Now
        </button>
      )}
    </div>
  );
}
